export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "初期化エラー",
    "StaticConfigLoader.caption.init": "初期化",
    "StaticConfigLoader.text.init": "アプリケーションを初期化中...",
    "StaticConfigLoader.error.settings": "サイト設定を読み込めません",
    "StaticConfigLoader.error.circuits": "サービス設定を読み込めません",
    //app
    "Legal.Localization": "ja",
    "AchievementApp.Navbar.storeTitle": "ストア",
    "AchievementApp.Navbar.supportTitle": "サポート",
    "Legal.TermsConditions": "利用規約",
    "Legal.TermsService": "サービス規約",
    "Legal.PrivacyPolicy": "プライバシーポリシー",
    "Legal.CookiesPolicy": "Cookieの設定",
    "Legal.Copyright": "すべての商標、ロゴ、ブランド名はそれぞれの所有者の所有物です。",
    "AchievementApp.Navbar.achievement": "個人実績",
    "AchievementApp.Navbar.userAchievement": "ユーザー実績",
    "AchievementApp.Navbar.settingsLink": "設定",
    "AchievementApp.Navbar.profileLink": "プロフィール",
    "AchievementApp.Navbar.reloginLink": "再ログインまたはアカウントの変更",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net実績",
    //commonAssets
    "ViewItemDetailed.state.completed": "完了",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "タイトルで絞り込む",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "マイフレンド",
    "UserFriendsList.heading.showMore": "もっと見る",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "2要素認証を設定する必要があります",
    "LimitedAccountPanel.2step.link": "2要素認証の詳細",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "メールアドレスを確認する必要があります",
    "LimitedAccountPanel.email.link": "プロフィールに進んでください",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "あなたのアカウントは以下の理由で制限されています:",
    "LimitedAccountPanel.conclusion": "セキュリティ設定を変更した後、変更を有効にするには、一度ログアウトしてから再度ログインする必要があります",
    "LimitedAccountPanel.relogin": "再ログイン",
    "EmailVerificationStateIcon.success": "アカウント確認済み、メールアドレス認証済み",
    "EmailVerificationStateIcon.warning": "アカウント未確認、メールアドレス未認証",
    "EmailVerificationStateIcon.danger": "アカウント未確認、メールアドレスの認証が必要です",
    "TwoFactorStateIcon.success": "2要素認証で保護されたアカウント",
    "TwoFactorStateIcon.warning": "安全でないアカウント、2要素認証が無効です",
    "TwoFactorStateIcon.danger": "2要素認証が必要です",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "設定を保存",
    "UserSettingDialog.settings": "設定",
    "UserSettingDialog.userSettings": "ユーザー設定",
    "UserSettingDialog.language": "言語",
    "UserSettingDialog.privacy": "プライバシー",
    "UserSettingDialog.allUsers": "全てのユーザー",
    "UserSettingDialog.friendsOnly": "フレンドのみ",
    "UserSettingDialog.onlyMe": "自分のみ",
    "UserSettingDialog.whoCanView": "自分の実績を見れるユーザー",
    //unlockProgress
    "ViewUnlockProgress.of": " の ",
    "ViewUnlockProgress.achievCompleted": " 実績完了",
    "ViewUnlockProgress.myUnlock": "自分の実績",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "ニックネームで検索",
    "ViewItemSearch.label.search": "ユーザーを検索",
    "ViewItemSearch.resultNotFound": "ユーザーが見つかりません",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "実績",
    "ViewItemSearch.stub.empty": "実績なし",
    "ViewItemSearch.stub.emptyCompare_1": "ユーザー ",
    "ViewItemSearch.stub.emptyCompare_2": " このゲームの実績がありません",
    "ViewItemSearch.limitedAccess": "選択したユーザー実績へのアクセスは限定されています",
    "ViewItemSearch.heading.selectGame": "リストからゲームを選択してください",
    "ViewItemSearch.globalstat.opened": "以下でアンロック ",
    "ViewItemSearch.globalstat.ofGamers": "%のゲーマー",
    //authentication
    "NotAllowedMessage.caption": "許可されていません",
    "NotAllowedMessage.body.h1": "実績へのアクセス",
    "NotAllowedMessage.body.h3": "現在あなたのアカウントでは許可されていません",
    "NotAllowedMessage.relogin": "アカウントの変更",
    "LandingMessage.caption": "認証",
    "LandingMessage.body": "着陸完了中...",
    "TokenExpiredMessage.caption": "認証期限切れ",
    "TokenExpiredMessage.body.h3": "私たちができることはあまりありませんが、以下が可能です",
    "TokenExpiredMessage.relogin": "再ログイン",
    "AuthErrorMessage.caption": "認証失敗",
    "AuthErrorMessage.body.h1": "認証に失敗しました",
    "AuthErrorMessage.body.code": "コード",
    "AuthErrorMessage.body.desc": "私たちができることはあまりありませんが、以下が可能です",
    "AuthErrorMessage.relogin": "再ログイン",
    "AuthorizationRequiredMessage.caption": "認証が必要です",
    "AuthorizationRequiredMessage.body.h3.1": "以下に入ろうとしています",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "しかし、この先へ進むには認証が必要です",
    "AuthorizationRequiredMessage.login": "Gaijin.Netでサインインする",
    "CheckingAuthMessage.caption": "認証",
    "CheckingAuthMessage.body": "認証確認中です。少々お待ちください",
    "AuthorizationRequiredMessageMobile.body.h3.1": "モバイル版は一時的に使用できません",
    "AuthorizationRequiredMessageMobile.body.h3.2": "コンピューター版をご利用ください",
    "AuthorizationRequiredMessageMobile.body.h3.3": "申し訳ございません",
}